import { FC } from "react";
import cn from "classnames";
import { IconChevronDown } from "@icons";
import { SSB_HIDE_STRATEGY, SSB_VIEW_STRATEGY } from "../Strategy.constants";
import "./StrategyViewToggle.styles.scss";

interface StrategyViewToggleProps {
    isExpanded: boolean;
    onToggle: () => void;
}

const StrategyViewToggle: FC<StrategyViewToggleProps> = ({ isExpanded, onToggle }) => (
    <button
        type="button"
        className="StrategyViewToggle"
        aria-expanded={isExpanded}
        onClick={onToggle}
    >
        <span className="StrategyViewToggle__label">{isExpanded ? SSB_HIDE_STRATEGY : SSB_VIEW_STRATEGY}</span>
        <span className="StrategyViewToggle__icon-wrap">
            <IconChevronDown
                className={cn("StrategyViewToggle__icon", isExpanded && "StrategyViewToggle__icon--expanded")}
                aria-hidden="true"
            />
        </span>
    </button>
);

export default StrategyViewToggle;
